import React, { Component } from "react";

export default class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
    };

    this.updateInfo = this.updateInfo.bind(this);
  }

  handleClick() {
    this.props.categoryClick(this.props.index, this.props.catId);
  }

  componentDidMount() {
    this.updateInfo();
  }

  componentDidUpdate(prvProps) {
    if (
      prvProps.nameObj !== this.props.nameObj ||
      prvProps.currentLang !== this.props.currentLang
    ) {
      this.updateInfo();
    }
  }

  updateInfo() {
    let title = "";
    this.props.nameObj.forEach((element) => {
      if (element.languageId === this.props.currentLang.languageId) {
        title = element.name;
      }
    });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (element.languageId === this.props.defaultLangId) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (title === "") {
          title = element.name;
        }
      });
    }

    this.setState({ title: title });
  }

  render() {
    return (
      <div
        onClick={this.handleClick.bind(this)}
        className={
          !this.props.isActive ? "menu-link" : "menu-link menu-link-active"
        }
      >
        {" "}
        {this.state.title}
      </div>
    );
  }
}
